// extracted by mini-css-extract-plugin
export default {"modalContent":"Ai-z"};